























































import { defineComponent, ref } from '@vue/composition-api'
import ComponentBasic from '@/components/basic-components/index.vue'
import ComponentLibrary from '@/components/component-library/index.vue'
import ComponentCompose from '@/components/component-compose/index.vue'
import ComponentUpload from '@/components/component-upload/index.vue'
import ComponentUmd from '@/components/component-umd/index.vue'
import GlobalUtils from '@/components/global-utils/index.vue'
import { project } from '@/assets/project'
import { showImageResource, showSearchCode } from '@/assets/render'

export default defineComponent({
  components: {
    ComponentBasic,
    ComponentLibrary,
    ComponentCompose,
    ComponentUpload,
    ComponentUmd,
    GlobalUtils
  },
  computed: {
    info () {
      return {
        dir: project.dir,
        desc: project.desc
      }
    }
  },
  setup () {
    const localShowState = ref<{ [k: string]: boolean }>({
      [ComponentCompose.name]: false,
      [ComponentUpload.name]: false,
      [ComponentUmd.name]: false,
      [GlobalUtils.name]: false
    })
    return {
      opts: [
        {
          title: '基础组件',
          icon: 'el-icon-folder',
          component: ComponentBasic.name
        },
        {
          title: '内置组件',
          icon: 'el-icon-folder-opened',
          component: ComponentLibrary.name
        },
        {
          title: '封装组件',
          icon: 'el-icon-folder-add',
          component: ComponentCompose.name
        },
        {
          title: '上传组件',
          icon: 'el-icon-folder-checked',
          component: ComponentUpload.name
        },
        {
          title: 'cdn 库',
          icon: 'el-icon-paperclip',
          component: ComponentUmd.name
        },
        {
          title: '工具函数库',
          icon: 'el-icon-scissors',
          component: GlobalUtils.name
        }
      ],
      showImageResource,
      localShowState,
      handleComponentShow (item: { component: string }, show: boolean) {
        localShowState.value[item.component] = show
      }
    }
  },
  methods: {
    handleShowImage () {
      showImageResource.value = true
    },
    handleShowSearchCode () {
      showSearchCode.value = true
    },
    handleHidePopover () {
      document.body.click()
    },
    handleOpen () {
      if (project.url) {
        window.open(project.url)
      } else {
        window.open(process.env.VUE_APP_MOBILE + `#/project/${project.dir}`)
      }
    }
  }
})
